import React from 'react';
import style from './Messages.css';
const MessagesComponent = ({ messages, clearMessage }) => (React.createElement("div", { className: style.titlebarMessage }, messages.map(m => (React.createElement("div", { key: m.messageId, className: style[m.messageType] },
    React.createElement("span", { className: style.messageType }, m.messageType),
    React.createElement("span", { className: style.messageText },
        m.text,
        " "),
    React.createElement("span", { onClick: clearMessage, className: style.clearMessage, "data-messageid": m.messageId }, "x"))))));
export default MessagesComponent;
